import { createReducer, on } from '@ngrx/store';
import { moduleActions } from '../actions/module.actions';
import { Module } from '../models';
import { BaseState, StateManager } from '@app/store/shared';

export interface ModuleState {
    items: Record<string, BaseState<Module>>;
}

export const initialState: ModuleState = {
    items: {},
};

export const moduleReducer = createReducer(
    initialState,
    on(moduleActions.getModule, (state, payload): ModuleState => {
        if (state.items[payload.id] === undefined) {
            return {
                ...state,
                items: {
                    ...state.items,
                    [payload.id]: StateManager.initial(true),
                },
            };
        }

        return state;
    }),
    on(moduleActions.getModuleSuccess, (state, { module }): ModuleState => {
        return {
            ...state,
            items: {
                ...state.items,
                [module.id]: StateManager.setLoaded(state.items[module.id], module),
            },
        };
    }),
    on(moduleActions.getModuleError, (state, { id }): ModuleState => ({
        ...state,
        items: {
            ...state.items,
            [id]: StateManager.setError(state.items[id]),
        },
    })),
    on(moduleActions.clear, (): ModuleState => ({
        ...initialState,
    })),
);
